// Module
var code = "<input type=\"text\" class=\"form-control\" ng-model=\"vm.value\" id=\"fieldresponse_{{vm.fieldResponse.id}}\" placeholder=\"{{ vm.requiredPlaceholderText | lowercase }}\"> ";
// Exports
module.exports = code;